import { Grid } from "@mui/material";
import { useState } from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  ResponsiveContainer,
  CartesianGrid,
} from "recharts";

type SubscriptionData = {
  planName: string;
  activeUser: number;
  requestedUser: number;
};

interface SubscriptionBarChartProps {
  data: SubscriptionData[];
}

const SubscriptionBarChart: React.FC<SubscriptionBarChartProps> = ({
  data,
}) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  return (
    <Grid item xs={12} sm={12} md={6} lg={6} xl={6} padding={3}>
      <div className="bg-white shadow-lg rounded-lg p-5 h-[60vh] max-w-3xl mx-auto">
        {/* Chart Title */}
        <h1 className="text-center font-satoshi font-extrabold mb-6 bg-orange-50 text-[#027aae] rounded-md">
        Plan Wise User Distribution
        </h1>

        {/* Loading, Error, or Data */}
        {loading ? (
          <p className="text-blue-500 text-center font-medium">
            Loading data...
          </p>
        ) : error ? (
          <p className="text-red-500 text-center font-medium">{error}</p>
        ) : (
          <ResponsiveContainer width="100%" height='85%'>
            <BarChart
              data={data}
              margin={{ top: 25, right: 60, left: 20, bottom: 10 }}
            >
              <CartesianGrid strokeDasharray="3 3" />
              <XAxis
                dataKey="planName"
                tick={{
                  fill: "#FFA500",
                  fontFamily: "satoshi",
                  fontSize: "12px",
                }}
              />
              <YAxis
                    tick={{ fill: "#00BFFF", fontFamily: "satoshi" }}
                    label={{
                      value: "Number of Users", // Title for the Y-axis
                      angle: -90, // Rotate vertically
                      position: "insideLeft", // Position it inside on the left
                      style: {
                        textAnchor: "middle",
                        fill: "#027aae",
                        fontSize: "14px",
                      },
                    }}
                  />
               <Tooltip
                    contentStyle={{
                      backgroundColor: "#fff",
                      borderRadius: 8,
                      color: "#027aae",
                      fontFamily: "satoshi",
                    }}
                  />
              <Legend />
              <Bar
                dataKey="activeUser"
                fill="#027aae"
                name="Active Users"
                barSize={10}
                radius={[0, 0, 0, 0]}
              />
              <Bar
                dataKey="requestedUser"
                fill="#FFA500"
                name="Requested Users"
                barSize={10}
                radius={[0, 0, 0, 0]}
              />
            </BarChart>
          </ResponsiveContainer>
        )}
      </div>
    </Grid>
  );
};

export default SubscriptionBarChart;
